import { getGetStalledPlatformMessagesQueryKey, useCreatePlatformMessageTestMessage } from "@bvhi/backend-api";
import { Card, CardContent, CardHeader, LoadingButton } from "@bvhi/ui-base";
import { EmailIcon } from "@bvhi/ui-icons";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "../../../../../hooks/use-toast";
import { useQueryClient } from "@tanstack/react-query";

export const MessagesTestMessageCard = () => {
  const { t } = useTranslation(["settings"]);
  const queryClient = useQueryClient();
  const { mutate: requestTestMessage, isPending: requestIsPending } = useCreatePlatformMessageTestMessage();
  const { pushCustomErrorToast, pushCreateSuccessToast } = useToast();

  const request = useCallback(() => {
    requestTestMessage(
      (() => {
        // this is just to please TypeScript
      })(),
      {
        onSuccess: () => {
          pushCreateSuccessToast(t("settings:test.message.toast.success"));
        },
        onError: () => pushCustomErrorToast(t("settings:test.message.toast.error")),
        onSettled: () => {
          void queryClient.invalidateQueries({
            queryKey: getGetStalledPlatformMessagesQueryKey({}),
          });
        },
      }
    );
  }, [pushCustomErrorToast, queryClient, pushCreateSuccessToast, requestTestMessage, t]);

  return (
    <>
      <Card>
        <CardHeader subheader={t("settings:test.message.card.subheader")} title={t("settings:test.message.card.title")} />
        <CardContent>
          <LoadingButton loading={requestIsPending} onClick={request} startIcon={<EmailIcon />}>
            {t("settings:test.message.card.button.label")}
          </LoadingButton>
        </CardContent>
      </Card>
    </>
  );
};
